import React, { Fragment } from "react";

const DefaultHelmetMeta = () => (
  <Fragment>
    <meta name="description" content="Largest online dental platform for dentists to showcase and discover great dental work." />
    <meta property="og:title" content="Casemasters | #1 Social Network for Dentists" />
    <meta property="og:description" content="Largest online dental platform for dentists to showcase and discover great dental work." />
    <meta property="og:image" content="https://casemasters.azureedge.net/public/fbpost-v-zXr4v4onaL.jpg" />
    <meta property="og:image:type" content="image/png" />
  </Fragment>
);

export default DefaultHelmetMeta;



// WEBPACK FOOTER //
// ./src/components/DefaultHelmetMeta.js